import React from 'react';

const Footer = () => {
  return (
    <footer className='p-10'>
      <div className='my-10 text-center'>
        <p>Copyright © 2022 - All right Reserved by Books Warehouse</p>
      </div>
    </footer>
  );
};

export default Footer;
